"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamTemplate = void 0;
var TeamCreationRequirements_1 = require("./TeamCreationRequirements");
var octopus_common_1 = require("@playq/octopus-common");
var services_shared_1 = require("@playq/services-shared");
var services_clerk_1 = require("@playq/services-clerk");
var TeamScoreSettings_1 = require("./TeamScoreSettings");
var TeamTemplateData_1 = require("./TeamTemplateData");
var services_common_traits_1 = require("@playq/services-common-traits");
var TeamTemplateVersion_1 = require("./TeamTemplateVersion");
var Limits_1 = require("./Limits");
var Hierarchy_1 = require("./Hierarchy");
var TeamTemplate = (function () {
    function TeamTemplate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.joinRequirements = [];
            this.tags = [];
            this.meta = {};
            this.teamDataTypes = {};
            this.userDataTypes = {};
            this.userTraitsTypes = {};
            return;
        }
        this.name = data.name;
        this.limits = new Limits_1.Limits(data.limits);
        this.teamCreationRequirements = new TeamCreationRequirements_1.TeamCreationRequirements(data.teamCreationRequirements);
        this.joinRequirements = data.joinRequirements.slice();
        this.hierarchy = new Hierarchy_1.Hierarchy(data.hierarchy);
        this.ladderOrder = services_clerk_1.OrderBy[data.ladderOrder];
        this.serverSidePayment = data.serverSidePayment;
        this.tags = data.tags.map(function (e) { return new octopus_common_1.Tag(e); });
        this.meta = Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {});
        this.teamDataTypes = Object.keys(data.teamDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[data.teamDataTypes[current]]; return previous; }, {});
        this.teamDataDefaults = typeof data.teamDataDefaults !== 'undefined' ? data.teamDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.userDataTypes = Object.keys(data.userDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[data.userDataTypes[current]]; return previous; }, {});
        this.userDataDefaults = typeof data.userDataDefaults !== 'undefined' ? data.userDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.userTraitsTypes = Object.keys(data.userTraitsTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[data.userTraitsTypes[current]]; return previous; }, {});
        this.userTraitsDefaults = typeof data.userTraitsDefaults !== 'undefined' ? data.userTraitsDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.scoreSettings = typeof data.scoreSettings !== 'undefined' ? new TeamScoreSettings_1.TeamScoreSettings(data.scoreSettings) : undefined;
        this.version = new TeamTemplateVersion_1.TeamTemplateVersion(data.version);
        this.adminAbsenceTolerance = typeof data.adminAbsenceTolerance !== 'undefined' ? new services_shared_1.TgDuration(data.adminAbsenceTolerance) : undefined;
        this.memberAbsenceTolerance = typeof data.memberAbsenceTolerance !== 'undefined' ? new services_shared_1.TgDuration(data.memberAbsenceTolerance) : undefined;
        this.id = new services_shared_1.AppTeamTemplateId(data.id);
    }
    TeamTemplate.prototype.getPackageName = function () { return TeamTemplate.PackageName; };
    TeamTemplate.prototype.getClassName = function () { return TeamTemplate.ClassName; };
    TeamTemplate.prototype.getFullClassName = function () { return TeamTemplate.FullClassName; };
    Object.defineProperty(TeamTemplate.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "limits", {
        get: function () {
            return this._limits;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field limits is not optional');
            }
            this._limits = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "teamCreationRequirements", {
        get: function () {
            return this._teamCreationRequirements;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamCreationRequirements is not optional');
            }
            this._teamCreationRequirements = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "joinRequirements", {
        get: function () {
            return this._joinRequirements;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field joinRequirements is not optional');
            }
            this._joinRequirements = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "hierarchy", {
        get: function () {
            return this._hierarchy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field hierarchy is not optional');
            }
            this._hierarchy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "ladderOrder", {
        get: function () {
            return this._ladderOrder;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ladderOrder is not optional');
            }
            this._ladderOrder = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "serverSidePayment", {
        get: function () {
            return this._serverSidePayment;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field serverSidePayment is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field serverSidePayment expects boolean type, got ' + value);
            }
            this._serverSidePayment = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "tags", {
        get: function () {
            return this._tags;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field tags is not optional');
            }
            this._tags = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field meta is not optional');
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "teamDataTypes", {
        get: function () {
            return this._teamDataTypes;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamDataTypes is not optional');
            }
            this._teamDataTypes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "teamDataDefaults", {
        get: function () {
            return this._teamDataDefaults;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._teamDataDefaults = undefined;
                return;
            }
            this._teamDataDefaults = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "userDataTypes", {
        get: function () {
            return this._userDataTypes;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userDataTypes is not optional');
            }
            this._userDataTypes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "userDataDefaults", {
        get: function () {
            return this._userDataDefaults;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._userDataDefaults = undefined;
                return;
            }
            this._userDataDefaults = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "userTraitsTypes", {
        get: function () {
            return this._userTraitsTypes;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userTraitsTypes is not optional');
            }
            this._userTraitsTypes = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "userTraitsDefaults", {
        get: function () {
            return this._userTraitsDefaults;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._userTraitsDefaults = undefined;
                return;
            }
            this._userTraitsDefaults = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "scoreSettings", {
        get: function () {
            return this._scoreSettings;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._scoreSettings = undefined;
                return;
            }
            this._scoreSettings = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "adminAbsenceTolerance", {
        get: function () {
            return this._adminAbsenceTolerance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._adminAbsenceTolerance = undefined;
                return;
            }
            this._adminAbsenceTolerance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "memberAbsenceTolerance", {
        get: function () {
            return this._memberAbsenceTolerance;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._memberAbsenceTolerance = undefined;
                return;
            }
            this._memberAbsenceTolerance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TeamTemplate.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    TeamTemplate.prototype.toTeamTemplateDataSerialized = function () {
        var _this = this;
        return {
            name: this.name,
            limits: this.limits.serialize(),
            teamCreationRequirements: this.teamCreationRequirements.serialize(),
            joinRequirements: this.joinRequirements.slice(),
            hierarchy: this.hierarchy.serialize(),
            ladderOrder: services_clerk_1.OrderBy[this.ladderOrder],
            serverSidePayment: this.serverSidePayment,
            tags: this.tags.map(function (e) { return e.serialize(); }),
            meta: Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}),
            teamDataTypes: Object.keys(this.teamDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.teamDataTypes[current]]; return previous; }, {}),
            teamDataDefaults: typeof this.teamDataDefaults !== 'undefined' ? this.teamDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            userDataTypes: Object.keys(this.userDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.userDataTypes[current]]; return previous; }, {}),
            userDataDefaults: typeof this.userDataDefaults !== 'undefined' ? this.userDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            userTraitsTypes: Object.keys(this.userTraitsTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.userTraitsTypes[current]]; return previous; }, {}),
            userTraitsDefaults: typeof this.userTraitsDefaults !== 'undefined' ? this.userTraitsDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            scoreSettings: typeof this.scoreSettings !== 'undefined' ? this.scoreSettings.serialize() : undefined,
            version: this.version.serialize(),
            adminAbsenceTolerance: typeof this.adminAbsenceTolerance !== 'undefined' ? this.adminAbsenceTolerance.serialize() : undefined,
            memberAbsenceTolerance: typeof this.memberAbsenceTolerance !== 'undefined' ? this.memberAbsenceTolerance.serialize() : undefined
        };
    };
    TeamTemplate.prototype.toTeamTemplateData = function () {
        return new TeamTemplateData_1.TeamTemplateDataStruct(this.toTeamTemplateDataSerialized());
    };
    TeamTemplate.prototype.loadTeamTemplateDataSerialized = function (slice) {
        this.name = slice.name;
        this.limits = new Limits_1.Limits(slice.limits);
        this.teamCreationRequirements = new TeamCreationRequirements_1.TeamCreationRequirements(slice.teamCreationRequirements);
        this.joinRequirements = slice.joinRequirements.slice();
        this.hierarchy = new Hierarchy_1.Hierarchy(slice.hierarchy);
        this.ladderOrder = services_clerk_1.OrderBy[slice.ladderOrder];
        this.serverSidePayment = slice.serverSidePayment;
        this.tags = slice.tags.map(function (e) { return new octopus_common_1.Tag(e); });
        this.meta = Object.keys(slice.meta).reduce(function (previous, current) { previous[current] = slice.meta[current]; return previous; }, {});
        this.teamDataTypes = Object.keys(slice.teamDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[slice.teamDataTypes[current]]; return previous; }, {});
        this.teamDataDefaults = typeof slice.teamDataDefaults !== 'undefined' ? slice.teamDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.userDataTypes = Object.keys(slice.userDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[slice.userDataTypes[current]]; return previous; }, {});
        this.userDataDefaults = typeof slice.userDataDefaults !== 'undefined' ? slice.userDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.userTraitsTypes = Object.keys(slice.userTraitsTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[slice.userTraitsTypes[current]]; return previous; }, {});
        this.userTraitsDefaults = typeof slice.userTraitsDefaults !== 'undefined' ? slice.userTraitsDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.deserialize(e); }) : undefined;
        this.scoreSettings = typeof slice.scoreSettings !== 'undefined' ? new TeamScoreSettings_1.TeamScoreSettings(slice.scoreSettings) : undefined;
        this.version = new TeamTemplateVersion_1.TeamTemplateVersion(slice.version);
        this.adminAbsenceTolerance = typeof slice.adminAbsenceTolerance !== 'undefined' ? new services_shared_1.TgDuration(slice.adminAbsenceTolerance) : undefined;
        this.memberAbsenceTolerance = typeof slice.memberAbsenceTolerance !== 'undefined' ? new services_shared_1.TgDuration(slice.memberAbsenceTolerance) : undefined;
    };
    TeamTemplate.prototype.loadTeamTemplateData = function (slice) {
        this.loadTeamTemplateDataSerialized(slice.serialize());
    };
    TeamTemplate.prototype.serialize = function () {
        var _this = this;
        return {
            name: this.name,
            limits: this.limits.serialize(),
            teamCreationRequirements: this.teamCreationRequirements.serialize(),
            joinRequirements: this.joinRequirements.slice(),
            hierarchy: this.hierarchy.serialize(),
            ladderOrder: services_clerk_1.OrderBy[this.ladderOrder],
            serverSidePayment: this.serverSidePayment,
            tags: this.tags.map(function (e) { return e.serialize(); }),
            meta: Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}),
            teamDataTypes: Object.keys(this.teamDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.teamDataTypes[current]]; return previous; }, {}),
            teamDataDefaults: typeof this.teamDataDefaults !== 'undefined' ? this.teamDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            userDataTypes: Object.keys(this.userDataTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.userDataTypes[current]]; return previous; }, {}),
            userDataDefaults: typeof this.userDataDefaults !== 'undefined' ? this.userDataDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            userTraitsTypes: Object.keys(this.userTraitsTypes).reduce(function (previous, current) { previous[current] = services_common_traits_1.TraitDataType[_this.userTraitsTypes[current]]; return previous; }, {}),
            userTraitsDefaults: typeof this.userTraitsDefaults !== 'undefined' ? this.userTraitsDefaults.map(function (e) { return services_common_traits_1.TraitHelpers.serialize(e); }) : undefined,
            scoreSettings: typeof this.scoreSettings !== 'undefined' ? this.scoreSettings.serialize() : undefined,
            version: this.version.serialize(),
            adminAbsenceTolerance: typeof this.adminAbsenceTolerance !== 'undefined' ? this.adminAbsenceTolerance.serialize() : undefined,
            memberAbsenceTolerance: typeof this.memberAbsenceTolerance !== 'undefined' ? this.memberAbsenceTolerance.serialize() : undefined,
            id: this.id.serialize()
        };
    };
    TeamTemplate.PackageName = 'net.playq.services.teams';
    TeamTemplate.ClassName = 'TeamTemplate';
    TeamTemplate.FullClassName = 'net.playq.services.teams.TeamTemplate';
    return TeamTemplate;
}());
exports.TeamTemplate = TeamTemplate;
TeamTemplateData_1.TeamTemplateDataStruct.register(TeamTemplate.FullClassName, TeamTemplate);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(TeamTemplate.FullClassName, {
    full: TeamTemplate.FullClassName,
    short: TeamTemplate.ClassName,
    package: TeamTemplate.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new TeamTemplate(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'limits',
            accessName: 'limits',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.Limits' }
        },
        {
            name: 'teamCreationRequirements',
            accessName: 'teamCreationRequirements',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.TeamCreationRequirements' }
        },
        {
            name: 'joinRequirements',
            accessName: 'joinRequirements',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Str } }
        },
        {
            name: 'hierarchy',
            accessName: 'hierarchy',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.Hierarchy' }
        },
        {
            name: 'ladderOrder',
            accessName: 'ladderOrder',
            type: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.clerk.OrderBy' }
        },
        {
            name: 'serverSidePayment',
            accessName: 'serverSidePayment',
            type: { intro: irt_1.IntrospectorTypes.Bool }
        },
        {
            name: 'tags',
            accessName: 'tags',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus.common.Tag' } }
        },
        {
            name: 'meta',
            accessName: 'meta',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Str } }
        },
        {
            name: 'teamDataTypes',
            accessName: 'teamDataTypes',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.common.traits.TraitDataType' } }
        },
        {
            name: 'teamDataDefaults',
            accessName: 'teamDataDefaults',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Adt, full: 'net.playq.services.common.traits.Trait' } } }
        },
        {
            name: 'userDataTypes',
            accessName: 'userDataTypes',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.common.traits.TraitDataType' } }
        },
        {
            name: 'userDataDefaults',
            accessName: 'userDataDefaults',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Adt, full: 'net.playq.services.common.traits.Trait' } } }
        },
        {
            name: 'userTraitsTypes',
            accessName: 'userTraitsTypes',
            type: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.common.traits.TraitDataType' } }
        },
        {
            name: 'userTraitsDefaults',
            accessName: 'userTraitsDefaults',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Adt, full: 'net.playq.services.common.traits.Trait' } } }
        },
        {
            name: 'scoreSettings',
            accessName: 'scoreSettings',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.TeamScoreSettings' } }
        },
        {
            name: 'version',
            accessName: 'version',
            type: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.teams.TeamTemplateVersion' }
        },
        {
            name: 'adminAbsenceTolerance',
            accessName: 'adminAbsenceTolerance',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.shared.TgDuration' } }
        },
        {
            name: 'memberAbsenceTolerance',
            accessName: 'memberAbsenceTolerance',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.shared.TgDuration' } }
        },
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_1.IntrospectorTypes.Id, full: 'net.playq.services.shared.AppTeamTemplateId' }
        }
    ]
});
//# sourceMappingURL=TeamTemplate.js.map